@if (isCustomer) {
<div
  role="alert"
  [attr.aria-live]="'polite'"
  [attr.aria-label]="'Video call ended' | translate"
  class="container text-center"
>
  <h1 aria-hidden="true" [innerHTML]="'Video call ended' | translate"></h1>
  <p [innerHTML]="'Thank you for contacting us.' | translate"></p>
</div>
} @if (isAgent) {
<div
  role="alert"
  [attr.aria-live]="'polite'"
  [attr.aria-label]="'You left the call' | translate"
  class="container text-center"
>
  <h1 aria-hidden="true" [innerHTML]="'You left the call' | translate"></h1>
  <p [innerHTML]="'It is now safe to close this page.' | translate"></p>
</div>
}
